/**
 * Clé publique ES256 Nexxus pour vérification des licences JWT.
 * Synchronisée le 2026-08-12T10:29:43.360Z depuis nexxus-licensing-api.
 * NE PAS MODIFIER MANUELLEMENT — utiliser scripts/licence/sync-public-key.js
 */
export const NEXXUS_LICENCE_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAECtzYbSco6iMFWgAfn/InPCP0m14t
Xa3XONCuqkbDZ+tnL+fTVFB2BU0hPpyv8aCv1ZWu6ccfiVXmbdKhzm4BqA==
-----END PUBLIC KEY-----`;
